/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { CalculatorListPublic } from './CalculatorListPublic'
import {
  CalculatorListPublicFromJSON,
  CalculatorListPublicFromJSONTyped,
  CalculatorListPublicToJSON,
} from './CalculatorListPublic'

/**
 *
 * @export
 * @interface PaginatedCalculatorListPublic
 */
export interface PaginatedCalculatorListPublic {
  /**
   *
   * @type {Array<CalculatorListPublic>}
   * @memberof PaginatedCalculatorListPublic
   */
  results: Array<CalculatorListPublic>
  /**
   *
   * @type {number}
   * @memberof PaginatedCalculatorListPublic
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedCalculatorListPublic
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedCalculatorListPublic
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedCalculatorListPublic interface.
 */
export function instanceOfPaginatedCalculatorListPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedCalculatorListPublicFromJSON(json: any): PaginatedCalculatorListPublic {
  return PaginatedCalculatorListPublicFromJSONTyped(json, false)
}

export function PaginatedCalculatorListPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedCalculatorListPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(CalculatorListPublicFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedCalculatorListPublicToJSON(
  value?: PaginatedCalculatorListPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(CalculatorListPublicToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
